import axios from "axios";
import config from "../../config/config";
import Cookie from "cookies-js";

export const reportG7 = {
    getReportData,
    getReportDataFixed,
    getPropotion
};

function getReportData(data){
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "reportG7/getPromotionPercentReport/?authorization=" + json_cookie.token, data)
        // axios.post(config.API_URL + "reportG5/getAmountReport/?authorization=" + json_cookie.token, data)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}
function getReportDataFixed(data){
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject)=> {
        axios.post(config.API_URL + "reportG7/getPromotionPercentFixed/?authorization=" + json_cookie.token, data)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}
function getPropotion(data){
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject)=> {
        axios.post(config.API_URL + "reportG7/getPropotion/?authorization=" + json_cookie.token,data)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    }) 
}